import { mountReactComponent } from "@siisel/frontend-shared";
import type { ComponentType } from "react";
import BackgroundJobsWarmupFormApp from "./components/BackgroundJobsWarmupFormApp";
import CacheSettingsFormApp from "./components/CacheSettingsFormApp";
import ChangePasswordFormApp from "./components/ChangePasswordFormApp";
import ForgotPasswordFormApp from "./components/ForgotPasswordFormApp";
import HistorizationSettingsFormApp from "./components/HistorizationSettingsFormApp";
import LegacyFormApp from "./components/LegacyFormApp";
import LoginFormApp from "./components/LoginFormApp";
import PersonalHomePageFormApp from "./components/PersonalHomePageFormApp";
import ProjectGroupFormApp from "./components/ProjectGroupFormApp";
import ResetPasswordFormApp from "./components/ResetPasswordFormApp";
import SelectProjectGroupFormApp from "./components/SelectProjectGroupFormApp";
import SensorStreamWatchdogSettingsFormApp from "./components/SensorStreamWatchdogSettingsFormApp";
import type {
  BackgroundJobsWarmupFormViewModel,
  CacheSettingsFormViewModel,
  ChangePasswordFormViewModel,
  ForgotPasswordFormViewModel,
  HistorizationSettingsFormViewModel,
  LegacyFormViewModel,
  LoginFormViewModel,
  PersonalHomePageFormViewModel,
  ProjectGroupFormViewModel,
  ResetPasswordFormViewModel,
  SelectProjectGroupFormViewModel,
  SensorStreamWatchdogSettingsFormViewModel
} from "./types";
import "./styles.css";

type MountDefinition<TProps extends object> = {
  selector: string;
  Component: ComponentType<TProps>;
};

function mountComponent<TProps extends object>({ selector, Component }: MountDefinition<TProps>): void {
  mountReactComponent<TProps>({
    Component,
    mountedDataKey: "reactMounted",
    selector
  });
}

mountComponent<CacheSettingsFormViewModel>({
  selector: "[data-cache-settings-form-app-root='true']",
  Component: CacheSettingsFormApp
});
mountComponent<HistorizationSettingsFormViewModel>({
  selector: "[data-historization-settings-form-app-root='true']",
  Component: HistorizationSettingsFormApp
});
mountComponent<BackgroundJobsWarmupFormViewModel>({
  selector: "[data-background-jobs-warmup-form-app-root='true']",
  Component: BackgroundJobsWarmupFormApp
});
mountComponent<SensorStreamWatchdogSettingsFormViewModel>({
  selector: "[data-sensor-stream-watchdog-settings-form-app-root='true']",
  Component: SensorStreamWatchdogSettingsFormApp
});
mountComponent<ChangePasswordFormViewModel>({
  selector: "[data-change-password-form-app-root='true']",
  Component: ChangePasswordFormApp
});
mountComponent<ProjectGroupFormViewModel>({
  selector: "[data-project-group-form-app-root='true']",
  Component: ProjectGroupFormApp
});
mountComponent<ForgotPasswordFormViewModel>({
  selector: "[data-forgot-password-form-app-root='true']",
  Component: ForgotPasswordFormApp
});
mountComponent<ResetPasswordFormViewModel>({
  selector: "[data-reset-password-form-app-root='true']",
  Component: ResetPasswordFormApp
});
mountComponent<LoginFormViewModel>({
  selector: "[data-login-form-app-root='true']",
  Component: LoginFormApp
});
mountComponent<PersonalHomePageFormViewModel>({
  selector: "[data-personal-home-page-form-app-root='true']",
  Component: PersonalHomePageFormApp
});
mountComponent<SelectProjectGroupFormViewModel>({
  selector: "[data-select-project-group-form-app-root='true']",
  Component: SelectProjectGroupFormApp
});
mountComponent<LegacyFormViewModel>({
  selector: "[data-legacy-form-app-root='true']",
  Component: LegacyFormApp
});
